/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
// import PropTypes from 'prop-types'
import {
  // CRow,
  // CToast,
  // CToastHeader,
  // CToastBody,
  // CToaster,
  CModal,
  CModalHeader,
  CModalTitle,
  CToast,
  // CModalBody,
  // CModalFooter,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCheckCircle, cilWarning } from '@coreui/icons'

import './Toast.scss'

const ToastModal = ({ message, type = '' }) => {
  const [visible, setVisible] = useState(true)
  useEffect(() => {
    if (type !== 'error') {
      const timeout = setTimeout(() => {
        setVisible(false)
      }, 3000)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [type])

  return (
    <CModal
      backdrop="static"
      visible={visible}
      // onClose={onClose}
      aria-labelledby="toast-modal"
      className="custom-modal-container"
      id="toast-modal"
      // style={styles}
    >
      <CModalHeader>
        <div className="modal-header-container">
          {/* <div className="d-flex flex-row w-100"> */}
          {type && (
            <div className="icon-container">
              <span>
                <CIcon
                  icon={type === 'success' ? cilCheckCircle : cilWarning}
                  className={type === 'success' ? 'text-success' : 'text-danger'}
                  size="lg"
                />
              </span>
            </div>
          )}
          <div className="modal-text">
            <span>{message}</span>
          </div>
          {/* </div> */}
        </div>
      </CModalHeader>
    </CModal>
  )
}

const Toast = (message, type = '') => {
  // const styles = {
  //   '--modal-backdrop-bg': 'red !default',
  //   '--modal-backdrop-opacity': '1 !default',
  //   // '--modal-color': 'red',
  // }
  return (
    // <CToast
    //   className="rounded-0"
    //   autohide={false}
    // >
    //   <CToastHeader className="rounded-0 custom-toast-header" closeButton>
    //     <div className="d-flex flex-row w-100">
    //       {type && (
    //         <div className="icon-container">
    //           <span>
    //             <CIcon
    //               icon={type === 'success' ? cilCheckCircle : cilWarning}
    //               className={type === 'success' ? 'toast-text-success' : 'toast-text-error'}
    //               style={{ color: type === 'success' ? '#5aad46' : 'red' }}
    //               size="lg"
    //             />
    //           </span>
    //         </div>
    //       )}
    //       <span className={type === 'success' ? 'toast-text-success' : 'toast-text-error'}>
    //         {message}
    //       </span>
    //     </div>
    //     <strong className="me-auto"></strong>
    //   </CToastHeader>
    // </CToast>
    <>
      <ToastModal message={message} type={type} />
    </>
  )
}

export default Toast
